import { Add as AddIcon } from '@mui/icons-material';
import useDialogContext from 'components/DialogContainer/useDialogContext';
import { Button, useGetResourceLabel, useTranslate } from 'react-admin';

interface AddSubItemProps {
  /**
   * Overrides the resource the dialog context reports, for the label only.
   *
   * TVR-2158: this was declared and never read — the `resource` destructured off
   * `useDialogContext()` below shadowed it completely, so passing it did nothing at all, silently.
   * It is wired up rather than deleted so it mirrors `EditSubItem`, whose same-named prop is live
   * through react-admin's `useResourceContext(props)` prop-over-context precedence. All seven
   * production call sites pass nothing and are unaffected either way.
   */
  resource?: string;
  label?: string;
}

const AddSubItem = (props: AddSubItemProps) => {
  const { openCreateDialog, resource: dialogResource } = useDialogContext();
  const t = useTranslate();
  const getResourceLabel = useGetResourceLabel();
  const resource = props.resource ?? dialogResource;
  const resourceName = resource ? resource.toString() : '';

  let label;

  if (props.label) {
    label = props.label;
  } else {
    label = t('custom.actions.add', {
      name: (getResourceLabel(resourceName, 1) || '').replace(/^\w/, (c) => c.toLowerCase()),
      Name: getResourceLabel(resourceName, 1) || '',
    });
  }

  return (
    <Button label={label} onClick={openCreateDialog} sx={{ width: '100%', maxWidth: 200 }} variant="contained">
      <AddIcon />
    </Button>
  );
};

export default AddSubItem;
